import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';


class CompatibilityFeatures extends Component {
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#abortController;

    // Listen for the variantUpdate event on the document instead of a specific target
    document.addEventListener(ThemeEvents.variantUpdate, this.#updateAccordion, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort(); // Ensure the event listener is removed
  }

  /**
   * Morphs or removes/adds an element based on current and new element states
   * @param {Element | null | undefined} currentElement - The current element in the DOM
   * @param {Element | null | undefined} newElement - The new element from the server response
   * @param {Element | null} [insertReferenceElement] - Element to insert before if adding new element
   */
  #morphOrUpdateElement(currentElement, newElement, insertReferenceElement = null) {
    if (currentElement && newElement) {
      morph(currentElement, newElement);
    } else if (currentElement && !newElement) {
      currentElement.remove();
    } else if (!currentElement && newElement && insertReferenceElement) {
      insertReferenceElement.insertAdjacentElement('beforebegin', /** @type {Element} */ (newElement.cloneNode(true)));
    }
  }

  /**
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  #updateAccordion = async (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    // update compatibility features section
    const currentCompatibilityElement = this.querySelector('.compatibility-features-section');
    const newCompatibilityElement = event.detail.data.html.querySelector('.compatibility-features-section');
    if (currentCompatibilityElement != null || newCompatibilityElement != null) {
      this.#morphOrUpdateElement(currentCompatibilityElement, newCompatibilityElement);
    }
  };
}

if (!customElements.get('compatibility-features')) {
  customElements.define('compatibility-features', CompatibilityFeatures);
}